export default __webpack_public_path__ + "locales/sk/SmartBanner.json?hash=078db2148fdd74d2f3db6800588adf7f";